import { createFileRoute, Navigate } from "@tanstack/react-router";
import { AssetsV2Overview } from "../components/AssetsV2Overview";
import { EnterpriseCustomerSelectionCard } from "../components/EnterpriseCustomerState";
import { useFeatureFlags } from "../components/LaunchDarkly/useFeatureFlags";
import { ensureEnterpriseCustomerContext } from "../lib/enterpriseCustomerContext";

function AssetsV2RouteComponent() {
  const { externalCustomerId } = Route.useSearch();
  const { "enterprise-assets-v2": assetsV2Enabled } = useFeatureFlags();

  if (!externalCustomerId) {
    return <EnterpriseCustomerSelectionCard />;
  }

  if (!assetsV2Enabled) {
    return <Navigate to="/assets" search={{ externalCustomerId }} />;
  }

  return <AssetsV2Overview externalCustomerId={externalCustomerId} />;
}

export const Route = createFileRoute("/_app/assets-v2")({
  loaderDeps: ({ search }) => ({
    externalCustomerId: search.externalCustomerId,
  }),
  loader: async ({ context, deps }) => {
    if (deps.externalCustomerId) {
      await ensureEnterpriseCustomerContext(
        context.queryClient,
        deps.externalCustomerId,
      );
    }
  },
  component: AssetsV2RouteComponent,
});
